import { NotFoundPage } from "@components/NotFoundPage";
import { HelpContent } from "@help/HelpContent";
import { createFileRoute } from "@tanstack/react-router";
import type { MDXContent } from "mdx/types";

const contentModules = import.meta.glob<{ default: MDXContent }>(
  "../help/content/*.mdx",
);

export const Route = createFileRoute("/help/$topicId")({
  loader: async ({ params }) => {
    const modulePath = `../help/content/${params.topicId}.mdx`;
    const loader = contentModules[modulePath];

    if (loader) {
      const mod = await loader();
      return { content: mod.default };
    }

    return { content: null };
  },
  component: HelpTopicComponent,
});

function HelpTopicComponent() {
  const { content } = Route.useLoaderData();

  if (!content) {
    return <NotFoundPage />;
  }

  return (
    <div className="max-w-xl p-6">
      <HelpContent content={content} />
    </div>
  );
}
